import React, { useState } from 'react'
import SideMenu from './sideMenu/sideMenu'
export default function PostLoginLayoutRoute(props) {
  const [isOpen,setIsOpen] = useState(false)
  const getSize = (size) =>{
    setIsOpen(size)
  }
  return (
    <>
      {
        window.innerWidth > 700 ? 
            <div className='d-flex'>      
                  <SideMenu getsize={getSize}/>     
                  <div className={isOpen ? 'main-container p-0' : 'main-container-close p-0'}>
                    {props.children}
                  </div>  
            </div>
            :
            <div className='mob-layout'>
              {props.children}   
              <SideMenu /> 
            </div> 
      } 
    </>
  )
}
